// src/app/design/tailwind-screens.ts
// Keep in sync with tailwind.config.{js,ts} -> theme.screens
export const TAILWIND_SCREENS = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  } as const;
  
  // Convert to media queries Tailwind uses (min-width)
  export const TAILWIND_QUERIES = {
    sm: `(min-width: ${TAILWIND_SCREENS.sm})`,
    md: `(min-width: ${TAILWIND_SCREENS.md})`,
    lg: `(min-width: ${TAILWIND_SCREENS.lg})`,
    xl: `(min-width: ${TAILWIND_SCREENS.xl})`,
    '2xl': `(min-width: ${TAILWIND_SCREENS['2xl']})`,
  } as const;
  
  export type TailwindSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  